
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/password/new",
      function () {
        return require("private-next-pages/users/password/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/password/new"])
      });
    }
  